module.exports = __webpack_public_path__ + "static/media/MicPeople.6c20cb70.svg";